import React from 'react'

export default function Footer() {
  return (
    <footer className="bg-[#003D23] text-gray-300 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <div className="mb-4">
          <h3 className="text-xl font-bold text-white mb-2">PetroAprova</h3>
          <p className="text-sm text-gray-300">Material digital para concursos públicos.</p>
        </div>
        
        <p className="text-sm text-gray-400 mb-6">
          Conteúdo independente, sem vínculo com a Petrobras.
        </p>
        
        <p className="text-sm text-gray-500">
          © 2025 PetroAprova. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  )
}